import React, { Component } from "react";
import { connect } from 'react-redux';
import { setSubscriptionDetail, setloginDetails, setloginSubscriptionDetail, setupgradePopup } from '../../../reducers/counterSlice';
import axiosInstance from "../../configuration/Request";
import { encryptPassword } from "../../../utils/passwordEncryption";

const mapStateToProps = (state) => {
    return {
        reduxData: state.counterSlice
    };
};

const mapDispatchToProps = {
    setSubscriptionDetail, setloginDetails, setloginSubscriptionDetail, setupgradePopup
};

class Subscription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriptionPlanTenure: false, // temporarily default to monthly
            loader: false,
            subscriptionPlanData: [],
            subscribedPopUp: false,
            fromBilling: false,
            currentUserPlan: null,
            hideBack: false
        };
    }

    componentDidMount = () => {
        // Add event listener to handle BFcache (Back-Forward Cache)
        window.addEventListener('pageshow', this.handlePageShow);

        // Check if coming from billing page
        const searchParams = new URLSearchParams(window.location.search);
        const fromBilling = searchParams.get('fromBilling') === 'true';

        // Check if back button should be hidden
        const hideBack = searchParams.get('hideBack') === 'true';

        // Get current user's plan from Redux
        const loginSubs = this.props?.reduxData?.loginSubscriptionDetail || [];
        const currentUserPlan = (loginSubs.find(item => item.attributes?.active === true) || loginSubs[0])?.attributes?.plan;

        this.setState({
            loader: true,
            fromBilling: fromBilling,
            currentUserPlan: currentUserPlan,
            hideBack: hideBack
        });

        axiosInstance.get(process.env.REACT_APP_BASE_URL + `api/subscription-plans?populate=feature_lists&sort=id:ASC`)
            .then((res) => {
                if (res?.data?.data?.length > 0) {
                    this.setState({ subscriptionPlanData: res?.data?.data })
                }
            })
            .catch((err) => {
                console.error(" error:", err);
            })
            .finally(() => {
                this.setState({ loader: false });
            });
    };

    componentWillUnmount = () => {
        // Clean up event listener
        window.removeEventListener('pageshow', this.handlePageShow);
    }

    handlePageShow = (event) => {
        // If the page is loaded from cache (happens on back button)
        if (event.persisted) {
            this.setState({ loader: false });
        }
    };

    onProceedBtnClick = async (title, pricing, monthly_url, yearly_url, item, isDisabled) => {
        // Don't proceed if button is disabled
        if (isDisabled) {
            return;
        }

        var date = new Date();
        const reduxData = { ...item };
        reduxData['subscriptionPlanTenure'] = this.state?.subscriptionPlanTenure;
        reduxData['purchasedAt'] = date?.toISOString() ?? '';

        this.props?.setSubscriptionDetail(reduxData);

        // Fix: Check if pricing is 'FREE' string or if title is Bronze
        const isFree = pricing === 'FREE' || pricing === 0 || title?.toUpperCase() === 'BRONZE';

        if (isFree) {
            this.setState({ subscribedPopUp: true });
        } else {
            try {
                this.setState({ loader: true });
                const paymentData = {
                    plan: title,
                    frequency: this.state.subscriptionPlanTenure ? "yearly" : "monthly",
                    email: this.props?.reduxData?.registrationEmail || this.props?.reduxData?.loginDetails?.user?.email
                };

                const paymentResponse = await axiosInstance.post(
                    `${process.env.REACT_APP_BASE_URL}api/payment/subscription`,
                    paymentData
                );

                if (paymentResponse?.data?.url) {
                    window.location.href = paymentResponse?.data?.url;
                }
            } catch (error) {
                console.error("Payment API error:", error);
                this.setState({ loader: false });
            }
        }
    };

    onSubscribedyesClick = async () => {
        this.setState({ subscribedPopUp: false, loader: true });
        var date = new Date();
        let encryptedPassword = '';
        try {
            this.setState({ loader: true });
            encryptedPassword = await encryptPassword(this.props?.reduxData?.basicDetails?.password)
        } catch (error) {
            console.error('Failed to encrypt password:', error);
        }

        axiosInstance.post(`${process.env.REACT_APP_BASE_URL}api/auth/local`, {
            identifier: this.props?.reduxData?.registrationEmail,
            password: encryptedPassword,
        })
            .then((res) => {
                if (res?.data?.user?.confirmed) {
                    this.props.setloginDetails(res?.data);
                    const expiredate = new Date();
                    if (this.state?.subscriptionPlanTenure) {
                        expiredate.setFullYear(date.getFullYear() + 1);
                    } else {
                        expiredate.setDate(date.getDate() + 30);
                    }
                    axiosInstance
                        .post(`${process.env.REACT_APP_BASE_URL}api/user-subscription-details`, {
                            "data": {
                                "userid": res?.data?.user?.id,
                                "plan": 'Bronze',
                                "frequency": this.state?.subscriptionPlanTenure ? "yearly" : "monthly",
                                "amount": 'Free',
                                "subscription_date": date.toISOString() ?? '',
                                "active": true,
                                "expiry": expiredate.toISOString() ?? '',
                                "currency": '',
                                "subscription_id": null,
                                "session_id": '',
                                "is_cancelled": false,
                                "transaction_id": `uf_${Math.floor(1000 + Math.random() * 9000)}`,
                            }
                        })
                        .then((response) => {
                            axiosInstance
                                .get(process.env.REACT_APP_BASE_URL + `api/user-subscription-details?filters[userid][%24eq]=${res?.data?.user?.id}&active=true`)
                                .then((resp) => {
                                    this.props?.setloginSubscriptionDetail(resp?.data?.data?.filter(item => item.attributes?.active === true) || [])
                                    this.props?.setupgradePopup(true);
                                    this.props.history.push('/app/dashboard');
                                })
                                .catch((err) => {
                                    console.error(" error:", err);
                                })
                        })
                        .catch((err) => {
                            console.error("Authentication error:", err);
                        }).finally(() => {
                            this.setState({ loader: false })
                        });
                }
            })
            .catch((err) => {
                console.error("Authentication error:", err);
                this.setState({ loader: false })
            })
    }

    handleBackClick = () => {
        if (this.props.history.length > 1) {
            this.props.history.goBack();
        } else if (this.state.fromBilling) {
            this.props.history.push('/app/profile/billing');
        } else {
            this.props.history.push('/auth/login');
        }
    }

    render() {

        const planData = this.state.subscriptionPlanData;

        return (
            <>
                <div className="subscription-wrapper">
                    <div className="subscription-container">
                        {!this.state.hideBack && (
                            <button className="back-button" onClick={this.handleBackClick}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Back
                            </button>
                        )}

                        <div className="header-section">
                            <h1 className="main-title">Select your Subscription Plan</h1>
                            <p className="subtitle">Take your desired plan to get access to our content.</p>

                            {/* TEMPORARILY HIDE YEARLY PLAN
                            <div className="toggle-container">
                                <div className="toggle-wrapper">
                                    <span className="toggle-label">Monthly</span>
                                    <div
                                        className={`toggle-switch ${this.state.subscriptionPlanTenure ? 'on' : 'off'}`}
                                        onClick={() => this.setState(prev => ({ subscriptionPlanTenure: !prev.subscriptionPlanTenure }))}
                                    >
                                        <div className="toggle-slider"></div>
                                    </div>
                                    <span className="toggle-label">Yearly</span>
                                </div>
                            </div>
                            <div className="discount-badge">
                                <span className="star-icon">★</span>
                                Choose yearly for better discounts
                            </div>
                            */}
                        </div>

                        <div className="plans-grid">
                            {planData.map((item, index) => {
                                const { title, description, pricing, yearly_pricing, feature_lists } = item.attributes;
                                const isGold = title?.toUpperCase() === 'GOLD';
                                const isSilver = title?.toUpperCase() === 'SILVER';
                                const isBronze = title?.toUpperCase() === 'BRONZE';
                                const monthlyPrice = isBronze ? 'Free' : parseFloat(pricing);
                                const yearlyPrice = isBronze ? 0 : parseFloat(yearly_pricing);

                                // Disable Bronze plan if user is already Bronze
                                const isDisabled = isBronze && this.state.currentUserPlan?.toUpperCase() === 'BRONZE';

                                return (
                                    <div key={index} className={`plan-card ${isDisabled ? 'disabled-plan' : ''}`}>
                                        {isSilver && (
                                            <div className="recommended-badge">Recommended for you</div>
                                        )}

                                        <div className="plan-header">
                                            <div className="plan-name">{title}</div>

                                            {isBronze ? (
                                                this.state.subscriptionPlanTenure ? (
                                                    // YEARLY (show Free + $0.00)
                                                    <>
                                                        <div className="plan-price">Free</div>
                                                        <div className="plan-monthly-price">
                                                            ${(0).toFixed(2)}
                                                        </div>
                                                    </>
                                                ) : (
                                                    // MONTHLY (show only Free)
                                                    <div className="plan-price">Free</div>
                                                )
                                            ) : this.state.subscriptionPlanTenure ? (
                                                <>
                                                    <div className="plan-price">
                                                        ${yearlyPrice}.00<span className="period">/year</span>
                                                    </div>
                                                    <div className="plan-monthly-price">
                                                        ${(yearlyPrice / 12).toFixed(2)}/month
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="plan-price">
                                                    ${monthlyPrice.toFixed(2)}<span className="period">/month</span>
                                                </div>
                                            )}

                                            <div className="plan-description">{description}</div>
                                        </div>

                                        <div className="divider"></div>

                                        <div className="features-list">
                                            {feature_lists && feature_lists.data && feature_lists.data.map((feature, idx) => (
                                                <div key={idx} className="feature-item">
                                                    <svg className="feature-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                    <span className="feature-description">{feature.attributes.description}</span>
                                                </div>
                                            ))}
                                        </div>

                                        <button
                                            className={`proceed-button ${isDisabled ? 'disabled' : ''}`}
                                            onClick={() => this.onProceedBtnClick(title, pricing, null, null, item.attributes, isDisabled)}
                                            disabled={isDisabled}
                                        >
                                            {isDisabled ? 'Current Plan' : 'Proceed'}
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {this.state.loader && (
                    <div className="loader-backdrop">
                        <div className="loader-spinner"></div>
                    </div>
                )}

                {this.state.subscribedPopUp && (
                    <div className="sweet-alert-overlay">
                        <div className="sweet-alert-box">
                            <button
                                className="sweet-alert-close"
                                onClick={() => this.setState({ subscribedPopUp: false })}
                                aria-label="Close"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            <h2 className="sweet-alert-title">Success!</h2>
                            <p className="sweet-alert-text">
                                You have successfully subscribed to Bronze plan. You can now view drugs and discussion. Thank you!
                            </p>
                            <button
                                className="sweet-alert-button"
                                onClick={this.onSubscribedyesClick}
                            >
                                Go to dashboard
                            </button>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);